import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ManageTokensTab, RoutePath, generateRoutePath } from '../../app/router/config';
// import History from '../../components/manage-tokens/history'
import NoCtaWallet from '../../components/common/no-cta-wallet';
import Bridge from '../../components/manage-tokens/bridge';
import Buy from '../../components/manage-tokens/buy';
import Header from '../../components/manage-tokens/header';
import Transfer from '../../components/manage-tokens/transfer';
import { UserContext } from '../../context/user';
import Layout from '../../layout';
// import { appEnv } from '../../env'
export default function ManageTokens() {
    var t = useI18n().t;
    var tab = useParams().tab;
    var user = useContext(UserContext).user;
    var tabs = [
        {
            label: t('manage-tokens.tab.buy'),
            path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.BUY }),
            selected: tab === ManageTokensTab.BUY,
        },
        {
            label: t('manage-tokens.tab.transfer'),
            path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.TRANSFER }),
            selected: tab === ManageTokensTab.TRANSFER,
        },
        {
            label: t('manage-tokens.tab.bridge'),
            path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.BRIDGE }),
            selected: tab === ManageTokensTab.BRIDGE,
            // disabled: !appEnv.isTesting,
        },
        // {
        //   label: t('manage-tokens.tab.history'),
        //   path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.HISTORY }),
        //   selected: tab === ManageTokensTab.HISTORY,
        // },
    ];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { tabs: tabs }), !(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) ? (_jsx(NoCtaWallet, {})) : (_jsxs(_Fragment, { children: [tab === ManageTokensTab.BUY && _jsx(Buy, {}), tab === ManageTokensTab.TRANSFER && _jsx(Transfer, {}), tab === ManageTokensTab.BRIDGE && _jsx(Bridge, {})] }))] }) }));
}
